import Button from "../../components/Button";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer";
import TagLine from "./components/TagLine";
import style from "./style.module.css";
import React, { useEffect, useRef, useState } from "react";
import { images } from "../../assets/images";
import { points, employeeImg, jobOpening } from "./data";
import { useNavigate } from "react-router-dom";
const CareerScreen = () => {
  useEffect(() => {
    window.scrollTo(0, 0); // Scrolls to the top of the page when the component mounts
  }, []);
  // const [isActive, setIsActive] = useState(false);
  const [filter, setFilter] = useState("All");
  const filterOptions = useRef(Array.from({ length: 4 }));
  const loadMoreRef = useRef();
  const jobOpeningContainer = useRef();
  const navigate = useNavigate();
  console.log(jobOpeningContainer.current);
  const switchOption = (e) => {
    if (e.target.className === style.careerFilter) return;
    filterOptions.current.map(
      (option) => (option.className = style.filterOption)
    );
    e.target.className = style.filterOptionActive;
    setFilter(e.target.innerText);
    if (!(e.target.innerText === "All")) {
      loadMoreRef.current.style.display = "none";
      jobOpeningContainer.current.style.height = "auto";
      jobOpeningContainer.current.style.marginBottom = "150px";
    } else {
      loadMoreRef.current.style.display = "block";
      jobOpeningContainer.current.style.height = "650px";
      jobOpeningContainer.current.style.marginBottom = "0px";
    }
  };

  const expandDiv = (e) => {
    e.target.style.display = "none";
    jobOpeningContainer.current.style.height = "auto";
    jobOpeningContainer.current.style.marginBottom = "50px";
  };

  return (
    <>
      <Navbar text="Login/signup" />
      <div style={{ width: "calc(100%-0px)", overflow: "hidden" }}>
        <main className={style.main}>
          <div className={style.headLineContainer}>
            <div className={style.line1}>
              <img src={images.line1} alt="line" />
            </div>
            <TagLine text="Why and what is " />
            <div className={style.headLine}>
              Unlock your potential explore exciting career opportunities with
              us
            </div>
            <div className={style.headLinePara}>
              Avasify inspires individuals to pursue their passions and build a
              fulfilling career. It motivates individuals to take charge of
              their career paths.
            </div>
            <a href="#openPositions">
              <Button text="See open positions" />{" "}
            </a>
          </div>
          <div className={style.imageSection}>
            <img src={images.CareerImage} alt="work_place_image" />
          </div>
          <div className={style.pointContainer}>
            {points.map((point, index) => (
              <div className={style.individualPoint}>
                <div className={style.number}>{`0${index + 1}`}</div>
                <div className={style.heading}>{point.heading}</div>
                <div className={style.description}>{point.description}</div>
              </div>
            ))}
          </div>
          <div className={style.taglineContainer}>
            <TagLine text="Employee stories " />
          </div>
          <div className={style.storySection}>
            <div className={style.storyHeading}>Their stories with Avasify</div>
            <div className={style.storyDescription}>
              We share insightful stories that illuminate the diverse and
              dynamic career, providing valuable insights and motivation.
            </div>
            <div className={style.joinButton}>
              <Button text="Join our Team" />
            </div>
          </div>
          <div className={style.imgContainer}>
            {employeeImg.map((employee) => (
              <div className={style.employee}>
                <div className={style.employeeImg}>
                  <img src={employee.img} alt="employeeImg" />
                </div>
                {/* <div className={style.employeeName}>{employee.name}</div>
              <div className={style.employeeDesignation}>
                {employee.designation}
              </div>  */}
              </div>
            ))}
            <div className={style.line2}>
              <img src={images.line2} alt="line" />
            </div>
          </div>

          <div className={style.careerSection} id="openPositions">
            <div className={style.mobileViewLine2}>
              <img src={images.line2} alt="line" />
            </div>
            <div className={style.careerHeadingContainer}>
              <TagLine text="Career at " />
              <div className={style.careerHeading}>
                Open <span style={{ color: "Blue" }}>Positions</span>
              </div>
              <div className={style.careerDescription}>
                We are always looking for passionate, dynamic and talented
                individuals to join our team.
              </div>
            </div>
            <div
              className={style.careerFilter}
              onClick={(e) => switchOption(e)}
            >
              <div
                ref={(option) => (filterOptions.current[0] = option)}
                className={style.filterOptionActive}
              >
                All
              </div>
              <div
                ref={(option) => (filterOptions.current[1] = option)}
                className={style.filterOption}
              >
                Technology
              </div>
              <div
                ref={(option) => (filterOptions.current[2] = option)}
                className={style.filterOption}
              >
                Finance
              </div>
              <div
                ref={(option) => (filterOptions.current[3] = option)}
                className={style.filterOption}
              >
                Design
              </div>
            </div>
            <div
              ref={jobOpeningContainer}
              className={style.jobOpeningContainer}
            >
              {jobOpening
                .filter((job) =>
                  filter === "All" ? true : job.sector === filter
                )
                .map((job) => (
                  <div
                    className={style.job}
                    onClick={() => navigate("/jobdesc")}
                  >
                    <div className={style.jobFirstRow}>
                      <div className={style.jobName}>{job.jobName}</div>
                      <div
                        className={
                          job.jobLocation === "Remote, Home"
                            ? style.remote
                            : style.onSite
                        }
                      >
                        <div
                          className={
                            job.jobLocation === "Remote, Home"
                              ? style.remoteDot
                              : style.onSiteDot
                          }
                        ></div>
                        {job.jobLocation}
                      </div>
                    </div>
                    <div className={style.jobSecondRow}>
                      <div className={style.postDay}>{job.postDay}</div>
                      <div className={style.jobVaccancy}>{job.jobVaccancy}</div>
                    </div>
                    <div className={style.jobDescription}>
                      {job.jobDescription}
                    </div>
                    <div className={style.jobFourthRow}>
                      <div className={style.jobType}>
                        &#128338; {job.jobType}
                      </div>
                      <div className={style.salary}>&#8377; {job.salary}</div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </main>
        <div
          ref={loadMoreRef}
          className={style.moreButton}
          onClick={(e) => expandDiv(e)}
        >
          Load More
        </div>
        <div className={style.jobOverlay}></div>
        <div className={style.footer}>
          <Footer />
        </div>
      </div>
    </>
  );
};

export default CareerScreen;
